import { render } from "./DeliveryLocationTable.vue?vue&type=template&id=b5115434"
import script from "./DeliveryLocationTable.vue?vue&type=script&lang=js"
export * from "./DeliveryLocationTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__